<template>
  <div class="checkHistoryModal">
    <CustomTable
      title=""
      :rowsData="this.history"
      :columns="columns"
      :loading="isFetching"
      :custom-body="true"
      :small="true"
      :striped="true"
      :bordered="true"
      :sticky-header="false"
      separator="cell"
    >
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            <span
              style="display: flex; justify-content: center; width: 30px;"
              >{{props.row.index}}</span
            >
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            <b>{{props.row.check_name}}</b>
            <span style="display: block;"
              >Мастер: {{ props.row.call_employee_fio }}</span
            >
            <span style="display: block;"
              >Дата вызова: {{ props.row.call_date }}</span
            >
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <q-chip
              size="sm"
              outline
              square
              style="font-size: 12px; font-weight: 500;"
              :color="this.getStatusColor(props.row)"
              :label="props.row?.is_accepted ? 'Завершен' : props.row?.is_accepted === false ? 'Есть замечания' : 'На проверке'"
            />
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            <span
              v-if="props.row.comments"
              style="display: block;"
              >{{props.row.comments}}</span
            >
            <span
              v-if="props.row.check_date"
              style="display: block;"
              >{{props.row.check_date}}</span
            >
            <span
              v-if="props.row.check_employee_fio"
              style="display: block;"
              >{{props.row.check_employee_fio}}</span
            >
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <div class="checkHistoryModal__images">
              <CustomImg
                v-for="(url, idx) in props.row.file_urls"
                :key="idx"
                :src="API_URL + url"
                class="checkHistoryModal__image"
                :alt="`Фото замечания ${idx + 1}`"
                :show-default-img="false"
                :isStaticImg="true"
                loading="lazy"
                :onClick="() => onImageClick(idx, props.row.file_urls)"
              />
            </div>
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
    <q-dialog
      v-model="this.showGallery"
      transition-show="scale"
      transition-hide="scale"
    >
      <ModalGallery :data="this.galleryData" />
    </q-dialog>
  </div>
</template>

<script>
import CustomImg from '@/components/common/CustomImg';
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import ModalGallery from "@/components/modal/modals/modal-gallery";
import { API_URL } from '@/constants';
import { getFloorMapChecks } from "@/views/ResidentialSettings/services";
import { checkHistoryColumns } from './services';

export default {
  name: "check-group-history",
  components: {CustomImg, ModalGallery, CustomTable, CustomTableCell},
  props: ['data'],
  data() {
    return {
      API_URL,
      columns: checkHistoryColumns,
      history: null,
      isFetching: false,
      galleryData: null,
      showGallery: false,
    }
  },
  methods: {
    async getData() {
      const {data} = this.data
      this.isFetching = true
      const res = await getFloorMapChecks(data?.floor_map_id, data?.params)
      this.isFetching = false
      if(!res) return
      this.history = res
    },
    getFiles(file_urls) {
      return file_urls?.map(url => ({file_url: API_URL + url, file_name: url.split('/').reverse()[0], isStaticImg: true}))
    },
    onImageClick(idx, files) {
      this.openGallery(idx, files)
    },
    openGallery(idx, files) {
      this.galleryData = {imgIndex: idx, files: this.getFiles(files)}
      this.showGallery = true;
    },
    getStatusColor(data = {}) {
      if(data?.is_accepted) return 'green'
      if(data?.is_accepted === false) return 'red'
      return 'orange'
    },
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="scss">
.checkHistoryModal {
  min-width: 500px;
  max-width: 765px;

  @media (max-width: 576px) {
    min-width: 100%;
  }
}

.checkHistoryModal__title {
  margin-bottom: 12px;
  font-size: 20px;
  line-height: 27px;
}

.checkHistoryModal__comments {
  margin-bottom: 10px;
}

.checkHistoryModal__images {
  display: grid;
  grid-template-columns: 80px 80px 80px;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.checkHistoryModal__image {
  width: 80px;
  height: 100px;
  object-fit: cover;
  border-radius: 12px;
  cursor: pointer;
}

.checkHistoryModal__close {
  margin-top: 20px;
  padding: 8px 16px;
}
</style>
